const baseConfig = {
  production: [
    "https://spider.3x120.com/api/",
    "https://spider.3x120.com/api/",
    "https://spider.3x120.com:16001/",
  ],
  development: ["http://172.16.1.218:9999/", "http://172.16.1.218:9999"],
  dev: ["https://boss.3x120.com/api", "https://boss.3x120.com/api"],
  test203: ["http://172.16.1.203:9999/", "http://172.16.1.203:9999"],
  default: "dev",
  outputDir: "dist",
};

module.exports = {
  host: "localhost",
  port: "3000",
  apiVersion: "1.0",
  baseConfig,
  // API_ROOT: "http://172.16.1.208:9999/",
  API_ROOT: "https://boss.3x120.com/api",
  // API_GROUP_2: "http://172.16.1.208:8700",
  // API_GROUP_2: "http://localhost:8700",
  API_GROUP_2: "https://grow.3x120.com",
  // API_GROUP_3: "http://172.16.1.208:8706",
  // API_GROUP_3: "http://localhost:8706",
  API_GROUP_3: "https://r.3x120.com",
  // 用于附件上传api
  // API_GROUP_3:
  //   process.env.VUE_APP_TITLE !== "dev"
  //     ? baseConfig[process.env.VUE_APP_TITLE][2]
  //     : baseConfig[baseConfig.default][2],
  outputDir: baseConfig.outputDir,
  isRoot: true,
};

/*
 代码提交规范
 提交格式（注意冒号后面有空格）
 <type>: <subject>
 ---------------------示例----------------------------
feat: 新的功能
fix: 修复 bug
docs: 只是文档的更改
style: 不影响代码含义的更改 (例如空格、格式化、少了分号)
refactor: 既不是修复 bug 也不是添加新功能的代码更改
perf: 提高性能的代码更改
test: 添加或修正测试
chore: 对构建或者辅助工具的更改，例如生成文档
 */
